_collow.components.QuizElementsInOrder = class QuizElementsInOrder extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  questionElements;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    this.questionElements = this.root.querySelectorAll("[data-question]") 


    // Initializes drag-and-drop events
    document.addEventListener("DOMContentLoaded", () => {    
        const draggableItems = this.root.querySelectorAll(".question-option-draggable");

        draggableItems.forEach((item, index) => {
          item.dataset.optionIndex = index; 
          item.addEventListener("dragstart", this.drag);
          item.addEventListener("dragend", this.dragEnd);
          item.addEventListener("dragover", this.dragOver);
          item.addEventListener("dragleave", this.dragLeave);
          item.addEventListener("drop", this.drop);
          item.addEventListener("drop", this.checkAnswer);
        });
    });
    

    this.listen(document.body, "_collow.quiz-finished", this.showResults);
  }

  removeDragAndDropEvents = () => {
    const questionHidden = document.querySelector(".course__quiz-wrapper[hidden]");

    if (questionHidden) {
      const draggableItems = questionHidden.querySelectorAll(".question-option-draggable");
      
      draggableItems.forEach((item) => {
        item.removeEventListener("dragstart", this.drag);
        item.removeEventListener("dragend", this.dragEnd);
        item.removeEventListener("dragover", this.dragOver);
        item.removeEventListener("dragleave", this.dragLeave);
        item.removeEventListener("drop", this.drop);
        item.removeEventListener("drop", this.checkAnswer);
      });
    }
  };

  checkAnswer = () => {
    let rightAnswers = 0;
    let studentQuestionPosition = 0;
    let correctQuestionPosition = 0;
    this.correctAnswer = false;
  
    // Itera sobre todas as questões
    this.questionElements.forEach((question) => {
      if (!question.hasAttribute("hidden")) {
        studentQuestionPosition = Number(question.dataset.optionIndex) + 1;
        correctQuestionPosition = Number(question.dataset.quizAnswer);
  
        if (studentQuestionPosition === correctQuestionPosition) {
          rightAnswers += 1;
          question.dataset.quizCorrectAnswer = "correct";
        } else {
          question.dataset.quizCorrectAnswer = "wrong";
        }
      }
    });
    const studentPoints = rightAnswers * (this.params.points / this.questionElements.length);
    this.correctAnswer = this.questionElements.length === rightAnswers;
  
    this.sendAnswer(studentPoints);
  };

  sendAnswer = (points) => {
    this.dispatch(this.root, "_collow.quiz-points", {
      points,
      index: this.params.index,
    });
  };

  showResults = () => {
    this.dispatch(
      this.root,
      "_collow.quiz-finished",
      { correct: this.correctAnswer },
      false
    );

    this.dispatch(
      this.root,
      `_collow.hint-${this.params.index}`,
      this.correctAnswer
    );

    this.questionElements.forEach((el) =>{
      el.removeEventListener("dragstart", this.drag);
      el.removeEventListener("dragend", this.dragEnd);
      el.removeEventListener("dragover", this.dragOver);
      el.removeEventListener("dragleave", this.dragLeave);
      el.removeEventListener("drop", this.drop);
      el.removeEventListener("drop", this.checkAnswer)
    });
   
    this.questionElements.forEach(question => {
      if(question.dataset.quizCorrectAnswer === "correct" | question.dataset.quizCorrectAnswer === "true") {
        question.dataset.quizCorrectAnswer = true
      } else {
        question.dataset.quizCorrectAnswer = false
      }
    })
  };

  // Function called when the item is dragged over another item
  dragOver = (event) => {
    event.preventDefault();

    const target = event.target;

    if (target.classList.contains("question-option-draggable")) {
        const bounding = target.getBoundingClientRect();
        const offset = event.clientY - bounding.top;

        if (offset > bounding.height / 2) {
            target.classList.remove("over-top");
            target.classList.add("over-bottom");
        } else {
            target.classList.remove("over-bottom");
            target.classList.add("over-top");
        }
    }
  }

  // Removes the style when the item is no longer over the drop area
  dragLeave = (event) => {
    event.target.classList.remove("over-top", "over-bottom");
  }

  // Function called when the item is dropped
  drop = (event) => {
    event.preventDefault();
    const draggedIndex = event.dataTransfer.getData("text/plain");
    const activeIndex = Array.from(document.querySelectorAll(".course__quiz-wrapper")).findIndex(question => !question.hasAttribute("hidden"))
    const draggedElement = document.querySelector(`#optionsList${activeIndex} [data-option-index="${draggedIndex}"]`);
    const target = event.target;

    if (target.classList.contains("question-option-draggable")) {
        const bounding = target.getBoundingClientRect();
        const offset = event.clientY - bounding.top;

        if (offset > bounding.height / 2) {
            target.parentNode.insertBefore(draggedElement, target.nextSibling);
        } else {
            target.parentNode.insertBefore(draggedElement, target);
        }

        this.updateOptionIndexes(target.parentNode);
    }

    target.classList.remove("over-top", "over-bottom");
  }

  updateOptionIndexes = (container) => {
    const options = container.querySelectorAll('.question-option-draggable');

    options.forEach((option, index) => {
      option.setAttribute('data-option-index', index); // Updates the index
    });
  }

  // Function called when starting the drag
  drag = (event) => {
    event.dataTransfer.setData("text/plain", event.target.dataset.optionIndex);
    event.target.classList.add("dragging");
  }

  // Function called when ending the drag
  dragEnd = (event) => {
    event.target.classList.remove("dragging");
  }
};
